import { MetaFunction } from "@vercel/remix";

import { Container } from "~/components/questionnaire/components";

import PreNeedQuestionnaire from "./PreNeedQuestionnaire";

export const meta: MetaFunction = () => {
    return [{ title: "Plan for the future | Our Guidant" }];
};

export default function PlanForTheFuture() {
    return (
        <Container>
            <PreNeedQuestionnaire />
        </Container>
    );
}
